const weekViewSelector = "#action-week-view";

async function loadWeek(url, pushState = true) {
  const currentView = document.querySelector(weekViewSelector);
  if (!currentView) return;

  currentView.classList.add("is-loading");

  try {
    const response = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
    if (!response.ok) throw new Error(`Weekweergave laden mislukt (${response.status})`);

    const documentFragment = new DOMParser().parseFromString(await response.text(), "text/html");
    const nextView = documentFragment.querySelector(weekViewSelector);
    if (!nextView) throw new Error("Weekweergave ontbreekt in het antwoord");

    currentView.replaceWith(nextView);
    if (pushState) window.history.pushState({ actionWeek: true }, "", url);
  } catch (_error) {
    window.location.assign(url);
  }
}

document.addEventListener("click", (event) => {
  const link = event.target.closest("a[data-action-week-navigation]");
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  event.preventDefault();
  loadWeek(link.href);
});

document.addEventListener("submit", (event) => {
  const form = event.target.closest("form[data-action-week-navigation]");
  if (!form) return;

  event.preventDefault();
  const url = new URL(form.action, window.location.origin);
  new FormData(form).forEach((value, key) => url.searchParams.set(key, value));
  loadWeek(url.toString());
});

window.addEventListener("popstate", () => {
  if (document.querySelector(weekViewSelector)) loadWeek(window.location.href, false);
});
